import { ShieldCheck } from 'lucide-react';
import { useAuth } from '@/shared/auth';
import { Button, Card, CardBody, PageHeader } from '@/shared/components';
import { useEndSupport } from './useEndSupport';

/**
 * Kontosicherheit gehört zur eigenen Anmeldung des Plattform-Admins. Das Support-Token darf sie
 * nicht ändern (der Server antwortet 401); die Seite führt deshalb zurück in die Heimatsitzung.
 */
export function SupportHomeOnlyNotice() {
  const { support } = useAuth();
  const back = useEndSupport();
  return (
    <div className="mx-auto max-w-4xl">
      <PageHeader eyebrow="Eigenes Konto" title="Kontosicherheit" />
      <Card>
        <CardBody className="flex flex-col gap-4 p-5 sm:flex-row sm:items-start sm:p-7">
          <ShieldCheck size={22} aria-hidden className="text-sage flex-none" />
          <div className="min-w-0">
            <h2 className="font-serif text-2xl">Gehört zu Ihrer eigenen Anmeldung</h2>
            <p className="text-ink-soft mt-2 text-sm">
              Während der Support-Sitzung in „{support?.workspaceName}“ arbeiten Sie mit den Rechten
              dieses Workspace. Passwort und Zwei-Faktor-Anmeldung ändern Sie in Ihrem eigenen
              Workspace.
            </p>
            <Button
              type="button"
              variant="primary"
              size="lg"
              className="mt-5 w-full sm:w-auto"
              loading={back.pending}
              onClick={back.end}
            >
              {back.backLabel}
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
